import React from "react";
import { Collapsible, TextContainer, Button } from "@shopify/polaris";
import parse from "html-react-parser";
import { _ as __ } from 'ttag';
import Slider from "react-slick";
/* Import css files */
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import DataId from "./add_data_id";

class AnootationDetails extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
    }
    pad(num, size) {
        num = num.toString();
        while (num.length < size) num = "0" + num;
        return num;
    }
    secondsToTime(secs) {
        var seconds = Number(secs);
        var d = parseInt(Math.floor(seconds / (3600 * 24)));
        var h = parseInt(Math.floor((seconds % (3600 * 24)) / 3600));
        var m = parseInt(Math.floor((seconds % 3600) / 60));
        var s = parseInt(Math.floor(seconds % 60));
        var Days = d ? this.pad(d, 2) + "D" : "";
        var Hours = d > 0 || h > 0 ? this.pad(h, 2) + "H" : "";
        var Minute = d > 0 || h > 0 || m > 0 ? this.pad(m, 2) + "M" : "";
        var Seconds = d > 0 || h > 0 || m > 0 || s > 0 ? this.pad(s, 2) + "S" : "";
        var total_time = Days + " " + Hours + " " + Minute + " " + Seconds;
        return total_time;
    }
    timeFormat(time) {
        var timer_du = JSON.parse(time);
        timer_du["days"] = timer_du.days ? timer_du.days : 0;
        timer_du["hours"] = timer_du.hours ? timer_du.hours : 0;
        timer_du["minute"] = timer_du.minute ? timer_du.minute : 0;
        timer_du["seconds"] = timer_du.seconds ? timer_du.seconds : 0;
        var timer_seconds = parseInt(timer_du.days ? timer_du.days : 0) * 24 * 60 * 60 + parseInt(timer_du.hours ? timer_du.hours : 0) * 60 * 60 + parseInt(timer_du.minute ? timer_du.minute : 0) * 60 + parseInt(timer_du.seconds ? timer_du.seconds : 0);
        return this.secondsToTime(timer_seconds)
    }
     html_entity_decode = (str, quoteStyle = 1) => {
        DataId({text:"#accordian_btn"})
        
        if (str) {

            /**
             * NOTE:- IW0066 (19-03-2021)
             * If find new special-chars then add into entities object.
             * ENT_COMPAT:Will convert double-quotes and leave single-quotes alone.
             * ENT_QUOTES:Will convert both double and single quotes.
             * ENT_NOQUOTES:Will leave both double and single quotes unconverted.
             */
            let OPTS = {
                'ENT_COMPAT': 1,
                'ENT_QUOTES': 2,
                'ENT_NOQUOTES': 3,
            };
            let entities = {
                '&amp;': '&',
                '&lt;': '<',
                '&gt;': '>',
                '&nbsp;': ' ',
                '&iexcl;': '¡',
                '&cent;': '¢',
                '&pound;': '£',
                '&curren;': '¤',
                '&yen;': '¥',
                '&brvbar;': '¦',
                '&sect;': '§',
                '&uml;': '¨',
                '&copy;': '©',
                '&ordf;': 'ª',
                '&laquo;': '«',
                '&not;': '¬',
                '&shy;': '',
                '&reg;': '®',
                '&macr;': '¯',
                '&deg;': '°',
                '&plusmn;': '±',
                '&sup2;': '²',
                '&sup3;': '³',
                '&acute;': '´',
                '&micro;': 'µ',
                '&para;': '¶',
                '&middot;': '·',
                '&cedil;': '¸',
                '&sup1;': '¹',
                '&ordm;': 'º',
                '&raquo;': '»',
                '&frac14;': '¼',
                '&frac12;': '½',
                '&frac34;': '¾',
                '&iquest;': '¿',
                '&Agrave;': 'À',
                '&Aacute;': 'Á',
                '&Acirc;': 'Â',
                '&Atilde;': 'Ã',
                '&Auml;': 'Ä',
                '&Aring;': 'Å',
                '&AElig;': 'Æ',
                '&Ccedil;': 'Ç',
                '&Egrave;': 'È',
                '&Eacute;': 'É',
                '&Ecirc;': 'Ê',
                '&Euml;': 'Ë',
                '&Igrave;': 'Ì',
                '&Iacute;': 'Í',
                '&Icirc;': 'Î',
                '&Iuml;': 'Ï',
                '&ETH;': 'Ð',
                '&Ntilde;': 'Ñ',
                '&Ograve;': 'Ò',
                '&Oacute;': 'Ó',
                '&Ocirc;': 'Ô',
                '&Otilde;': 'Õ',
                '&Ouml;': 'Ö',
                '&times;': '×',
                '&Oslash;': 'Ø',
                '&Ugrave;': 'Ù',
                '&Uacute;': 'Ú',
                '&Ucirc;': 'Û',
                '&Uuml;': 'Ü',
                '&Yacute;': 'Ý',
                '&THORN;': 'Þ',
                '&szlig;': 'ß',
                '&agrave;': 'à',
                '&aacute;': 'á',
                '&acirc;': 'â',
                '&atilde;': 'ã',
                '&auml;': 'ä',
                '&aring;': 'å',
                '&aelig;': 'æ',
                '&ccedil;': 'ç',
                '&egrave;': 'è',
                '&eacute;': 'é',
                '&ecirc;': 'ê',
                '&euml;': 'ë',
                '&igrave;': 'ì',
                '&iacute;': 'í',
                '&icirc;': 'î',
                '&iuml;': 'ï',
                '&eth;': 'ð',
                '&ntilde;': 'ñ',
                '&ograve;': 'ò',
                '&oacute;': 'ó',
                '&ocirc;': 'ô',
                '&otilde;': 'õ',
                '&ouml;': 'ö',
                '&divide;': '÷',
                '&oslash;': 'ø',
                '&ugrave;': 'ù',
                '&uacute;': 'ú',
                '&ucirc;': 'û',
                '&uuml;': 'ü',
                '&yacute;': 'ý',
                '&thorn;': 'þ',
                '&yuml;': 'ÿ',
                '&trade;': '™'
            }
            if (typeof quoteStyle !== 'number') {
                quoteStyle = OPTS[quoteStyle];
            }
            if (quoteStyle != 3) {
                entities['&quot;'] = '"';
            }
            if (quoteStyle == 2) {
                entities['&#39;'] = "'";
            }
            return str.replace(/&([^;]+);/gm, function (match) {
                return entities[match] || match;
            })
        }
        else {
            return str;
        }
    }
    render() {
        var settings = {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 2,
            slidesToScroll: 2
        };
        var settings_placeholder = {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1
        }
        if (this.props.ele.product_title !== null) {
            this.props.ele.product_title = this.props.ele.product_title.replaceAll("&nbsp;","")
            this.props.ele.product_title = this.props.ele.product_title.replaceAll("<p><br></p>","")
        }
        const pending = this.props.ele.total_pending;
        let product_title = this.html_entity_decode(this.props.ele.product_title)
        return (
            <>
                <Button data-id="offer_dropdown" onClick={(e) => this.props.accordion_handleToggle(e, this.props.ele, this.props.i, false, this.props.k)} ariaExpanded={this.props.ele.open} ariaControls="basic-collapsible" id="accordian_btn">
                    <div className="tooltip_title">
                        {/* <h4 className="text_overflow">{parseInt(this.props.ele.section_id) === 24 ? this.props.ele.product_title ? parse(this.props.ele.product_title) : "" : parse(this.props.ele.collection_title)}</h4>
                        <Icon source={this.props.ele.open ? CaretUpMinor : DropdownMinor} />
                        <span className="tooltiptext down_tooltip tooltip_text_overflow">{parseInt(this.props.ele.section_id) === 24 ? this.props.ele.product_title ? parse(this.props.ele.product_title) : "" : parse(this.props.ele.collection_title)}</span> */}
                        <h4 className="text_overflow">{parseInt(this.props.ele.section_id) === 24 ? this.props.ele.product_title ? parse(product_title) : "" : parse(this.props.ele.collection_title)}</h4>
                        {this.props.ele.open?
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                            <path fillRule="evenodd" clipRule="evenodd" d="M18 15.1147L12 9.16929L6 15.1147L18 15.1147Z" fill="#5C5F62"/>
                        </svg>
                        :
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                            <path fillRule="evenodd" clipRule="evenodd" d="M6 10.3584L12 16.3039L18 10.3584H6Z" fill="#5C5F62"/>
                        </svg>}
                         {/* <Icon source={this.props.ele.open ? CaretUpMinor : DropdownMinor} /> */}
                        <span className="tooltiptext down_tooltip tooltip_text_overflow">{parseInt(this.props.ele.section_id) === 24 ? this.props.ele.product_title ? parse(product_title) : "" : parse(this.props.ele.collection_title)}</span>

                    </div>
                </Button>
                <Collapsible open={this.props.ele.open} id="basic-collapsible" transition={{ duration: '150ms', timingFunction: 'ease' }} >
                    <TextContainer>
                        <div className="accordian_pannel">
                            {parseInt(this.props.ele.section_id) === 24 ?
                                <>
                                    {this.props.ele.main_image_gr && this.props.ele.main_image_gr !== "undefined" ?
                                        <div className="image_block"><img src={this.props.ele.main_image_gr} alt="main_image_gr" /></div>
                                        :

                                        <div className="image_block placeholder">
                                            {/* upsell */}
                                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="500" height="500" viewBox="0 0 500 500" fill="none">
                                                <rect x="0.233887" y="0.586914" width="500.904" height="502.517" rx="5" fill="#E5E5E5" />
                                                <rect x="136.131" y="165.277" width="218.532" height="172.08" fill="url(#pattern0)" />
                                                <defs>
                                                    <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
                                                        <use xlink="http://www.w3.org/1999/xlink" href="#image0" transform="scale(0.00483092 0.00613497)" />
                                                    </pattern>
                                                    <image id="image0" width="207" height="163" xlink="http://www.w3.org/1999/xlink" href="data:image/png;base64,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" />
                                                </defs>
                                            </svg>
                                        </div>
                                    }
                                </>
                                /* recommendation */
                                :
                                <>
                                    {this.props.ele.main_image_gr && this.props.ele.main_image_gr !== "undefined" && this.props.ele.main_image_gr !== "[]" && this.props.ele.main_image_gr.length !== 0 ?
                                        <div className="image_block">
                                            <Slider {...settings} className="recomm_slider">
                                                {
                                                    this.props.ele.main_image_gr.map(function (key, index) {
                                                        return (
                                                            <div key={index}>
                                                                <img src={key.product_image} alt="main_image_gr" />
                                                                <p>{key.product_name}</p>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </Slider>
                                        </div>
                                        :
                                        <div className="image_block placeholder">
                                            <Slider {...settings_placeholder} className="recomm_slider">
                                                <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" width="150px" height="150px" viewBox="0 0 150 150" enableBackground="new 0 0 150 150" space="preserve">
                                                    <rect x="0.25" y="0.333" fill="#F7F7F7" width="149.75" height="149.875" />
                                                    <path fill="#E5E5E5" stroke="#CECDD1" strokeWidth="2" d="M83.442,51h45.794c1.256,0,2.273,1.018,2.273,2.273v45.455  c0,1.255-1.018,2.272-2.273,2.272H83.442c-1.255,0-2.272-1.018-2.272-2.272V53.273C81.17,52.018,82.188,51,83.442,51z" />
                                                    <rect x="95.31" y="67.176" fill="none" width="22.399" height="17.31" />
                                                    <path fill="#E5E5E5" stroke="#CECDD1" strokeWidth="2" d="M20.994,51h45.455c1.255,0,2.272,1.018,2.272,2.273v45.455  c0,1.255-1.018,2.272-2.272,2.272H20.994c-1.255,0-2.273-1.018-2.273-2.272V53.273C18.721,52.018,19.739,51,20.994,51z" />
                                                    <rect x="32.521" y="67.176" fill="none" width="22.739" height="17.31" />
                                                    <g>
                                                        <rect x="30.333" y="65.993" fill="none" stroke="#999999" strokeMiterlimit="10" width="26.833" height="20.764" />
                                                        <polygon fill="#999999" points="33.592,83.308 37.968,78.579 38.396,78.436 39.186,78.879 39.857,79.19 45.906,72.829    48.126,75.497 48.718,75.624 49.181,75.273 49.852,75.561 55.01,83.467  " />
                                                        <circle fill="#999999" cx="38.881" cy="72.272" r="2.282" />
                                                    </g>
                                                    <g>
                                                        <rect x="93.334" y="65.993" fill="none" stroke="#999999" strokeMiterlimit="10" width="26.832" height="20.764" />
                                                        <polygon fill="#999999" points="96.592,83.308 100.969,78.579 101.396,78.436 102.186,78.879 102.857,79.19 108.906,72.829    111.127,75.497 111.718,75.624 112.181,75.273 112.852,75.561 118.01,83.467  " />
                                                        <circle fill="#999999" cx="101.88" cy="72.272" r="2.282" />
                                                    </g>
                                                </svg>
                                                <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" width="150px" height="150px" viewBox="0 0 150 150" enableBackground="new 0 0 150 150" space="preserve">
                                                    <rect x="0.25" y="0.333" fill="#F7F7F7" width="149.75" height="149.875" />
                                                    <path fill="#E5E5E5" stroke="#CECDD1" strokeWidth="2" d="M83.442,51h45.794c1.256,0,2.273,1.018,2.273,2.273v45.455  c0,1.255-1.018,2.272-2.273,2.272H83.442c-1.255,0-2.272-1.018-2.272-2.272V53.273C81.17,52.018,82.188,51,83.442,51z" />
                                                    <rect x="95.31" y="67.176" fill="none" width="22.399" height="17.31" />
                                                    <path fill="#E5E5E5" stroke="#CECDD1" strokeWidth="2" d="M20.994,51h45.455c1.255,0,2.272,1.018,2.272,2.273v45.455  c0,1.255-1.018,2.272-2.272,2.272H20.994c-1.255,0-2.273-1.018-2.273-2.272V53.273C18.721,52.018,19.739,51,20.994,51z" />
                                                    <rect x="32.521" y="67.176" fill="none" width="22.739" height="17.31" />
                                                    <g>
                                                        <rect x="30.333" y="65.993" fill="none" stroke="#999999" strokeMiterlimit="10" width="26.833" height="20.764" />
                                                        <polygon fill="#999999" points="33.592,83.308 37.968,78.579 38.396,78.436 39.186,78.879 39.857,79.19 45.906,72.829    48.126,75.497 48.718,75.624 49.181,75.273 49.852,75.561 55.01,83.467  " />
                                                        <circle fill="#999999" cx="38.881" cy="72.272" r="2.282" />
                                                    </g>
                                                    <g>
                                                        <rect x="93.334" y="65.993" fill="none" stroke="#999999" strokeMiterlimit="10" width="26.832" height="20.764" />
                                                        <polygon fill="#999999" points="96.592,83.308 100.969,78.579 101.396,78.436 102.186,78.879 102.857,79.19 108.906,72.829    111.127,75.497 111.718,75.624 112.181,75.273 112.852,75.561 118.01,83.467  " />
                                                        <circle fill="#999999" cx="101.88" cy="72.272" r="2.282" />
                                                    </g>
                                                </svg>

                                            </Slider>
                                        </div>
                                    }
                                </>
                            }


                            <div className="accrodian_text">
                                <p>{__('Discount')}: </p>
                                <p>{this.props.ele.discount_value ? this.props.ele.discount_type === "2" ? Number(this.props.ele.discount_value) + "%" : this.props.ele.discount_value : "-"}</p>
                            </div>
                            <div className="accrodian_text">
                                <p>{__('Timer')}: </p>
                                <p>{this.props.ele.timer_duration ? this.timeFormat(this.props.ele.timer_duration) : '-'}</p>
                            </div>
                            <div className="accrodian_text">
                                <p>{__('Impressions')}: </p>
                                <p>{this.props.ele.total == null || this.props.ele.total === 0 || this.props.ele.total === undefined ? 0 : this.props.ele.total}</p>
                            </div>
                            <div className="accrodian_text">
                                <p>{__('Accepted')}: </p>
                                <p>{this.props.ele.total === 0 || this.props.ele.total === undefined ? 0 : this.props.ele.accept_click_cnt}({(this.props.ele.total === 0 || this.props.ele.total === undefined ? 0 : 100 * this.props.ele.accept_click_cnt / this.props.ele.total).toFixed(2)}%)</p>
                            </div>
                            <div className="accrodian_text">
                                <p>{__('Declined')}: </p>
                                <p>{this.props.ele.total === 0 || this.props.ele.total === undefined ? 0 : this.props.ele.decline_click_cnt}({(this.props.ele.total === 0 || this.props.ele.total === undefined ? 0 : 100 * this.props.ele.decline_click_cnt / this.props.ele.total).toFixed(2)}%)</p>
                            </div>
                            <div className="accrodian_text">
                                <p>{__('Pending')}: </p>
                                <p>{this.props.ele.total === 0 || this.props.ele.total === undefined ? 0 : pending}({(this.props.ele.total === 0 || this.props.ele.total === undefined ? 0 : 100 * pending / this.props.ele.total).toFixed(2)}%)</p>
                            </div>
                            <div className="accrodian_text">
                                <p>{__('Revenue')}: </p>
                                <p>{this.props.ele.Revenue == null || this.props.ele.Revenue === 0 || this.props.ele.Revenue === undefined ? 0 : this.props.ele.Revenue}</p>
                            </div>
                            <div className="accrodian_text">
                                <p>{__('Closed')}: </p>
                                <p>{this.props.ele.total === 0 || this.props.ele.total === undefined ? 0 : this.props.ele.close_cnt == null || this.props.ele.close_cnt === 0 || this.props.ele.close_cnt === undefined ? 0 : this.props.ele.close_cnt}({(this.props.ele.total === 0 || this.props.ele.total === undefined ? 0 : 100 * (this.props.ele.close_cnt == null || this.props.ele.close_cnt === 0 || this.props.ele.close_cnt === undefined ? 0 : this.props.ele.close_cnt) / this.props.ele.total).toFixed(2)}%)</p>
                            </div>

                        </div>
                    </TextContainer>
                </Collapsible>
                <div className={"downsell_indicator_wrapper open_indicator_downsell"}>
                    {this.props.ele.downchild.length ?
                        <p className="span_txt_indicator downsell_indicator orange_badge">
                            {this.props.ele.downchild[0].temp_id !== 0 ? __('decline') : __('decline')}
                        </p>
                        :
                        <p className={"span_txt_indicator downsell_indicator orange_badge"}>{
                            this.props.tmp === "yes" ? __('decline') : __('decline')}</p>
                    }
                </div>
            </>
        );
    }
}

export default AnootationDetails;
